import jwt_decode from 'jwt-decode';
import { User } from 'oidc-client-ts';

import store from '../../redux/store';
import { setUser34 } from '../../redux/actions';

/**
 * Processes the OIDC profile and adds the users unique id into localstorage
 *
 * This replaces old auth functional helpers
 * @see {@link https://github.com/HCA-CDI/orbit-web-rewrite/blob/a5ed1ff4e2432fb49ac9a6258a2780e12805b3b5/src/services/AUTH/utils.js}
 */
const handleAuthToken = () => {
  const user = User.fromStorageString(
    sessionStorage.getItem(
      `oidc.user:${process.env.REACT_APP_SSO_URL}:${process.env.REACT_APP_SSO_OAUTH_CLIENT_ID}`
    ) ?? '{}'
  );
  // Possibly add a try catch here to capture thrown exceptions on token decode
  const decodedToken = jwt_decode(user.access_token);
  let userId =
    (decodedToken?.preferred_username ?? '').split('@')[0]?.toLowerCase() ?? '';
  if (process.env.REACT_APP_ENV === 'production')
    window.localStorage.setItem('34', userId);
  store.dispatch(setUser34(userId));
};

export { handleAuthToken };
